module.exports = __webpack_public_path__ + "static/media/roo_wor_sit_spe_met.af566856.png";